// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./index.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("4600833d", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@2.9.3@vant/lib/index.css
// module id = 232
// module chunks = 0